"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onClickRemovePassport = void 0;
var constants_1 = require("../constants");
var page = require("page");
function onClickRemovePassport(event) {
    event.preventDefault();
    page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PASSPORT.DELETE);
}
exports.onClickRemovePassport = onClickRemovePassport;
